<template>
  <div class="wrapper">
    <vue-confirm-dialog></vue-confirm-dialog>
    <div class="upload">
      <Header />
      <h2 class="page_title">マイページ</h2>
      <div class="form">
        <dl class="form_list">
          <dt>現パスワード</dt>
          <dd>
            <input
              type="passwd"
              v-model="now_passwd"
              placeholder="現在登録されているパスワード"
              :class="{'error':errors.now_passwd}"
              class="text-type03"
            />
            <span class="error__text" v-show="errors.now_passwd">{{errors.now_passwd}}</span>
          </dd>
          <dt>新パスワード</dt>
          <dd>
            <input
              type="passwd"
              v-model="passwd"
              placeholder="半角英数字8文字以上"
              :class="{'error':errors.passwd}"
              class="text-type03"
            />
            <span class="error__text" v-show="errors.passwd">{{errors.passwd}}</span>
          </dd>
          <dt>新パスワード（確認）</dt>
          <dd>
            <input
              type="passwd"
              v-model="passwd2"
              placeholder="変更後のパスワード（確認）"
              :class="{'error':errors.passwd2}"
              class="text-type03"
            />
            <span class="error__text" v-show="errors.passwd2">{{errors.passwd2}}</span>
          </dd>
        </dl>
        <div class="btnbox">
          <a href="/" class="linebtn_bold arrow_l">一覧へ戻る</a>
          <button type="button" v-on:click="setSubmit()" class="btn01 cl_pp">変更する</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Mixin } from "../mixin";
export default {
  name: "upload",
  mixins: [Mixin],
  data() {
    return {
      now_passwd: "",
      passwd: "",
      passwd2: "",
      errors: {}, // エラー
      connect_flg: false, // 通信フラグ
    };
  },
  async created() {
    //Loading Start
    var loader = this.loadingShow();
    let params = new URLSearchParams();
    params.append("c", "login_chk");
    params.append("lo_pk", this.$cookies.get("lo_pk"));
    params.append("lo_sid", this.$cookies.get("lo_sid"));
    await this.axios
      .post(this.RequestURI, params, {
        headers: {
          "Cache-Control": "no-cache",
        },
      })
      .then((response) => {
        if (response.data.status != "success") {
          // NG
          this.removeLogin();
        }
      })
      .catch(() => {
        this.removeLogin();
      });
    // Loading Finish
    loader.hide();
  },
  methods: {
    // 登録処理
    setSubmit() {
      this.errors = {}; // 初期化
      if (!this.now_passwd) this.errors.now_passwd = "未入力です";
      if (!this.passwd) this.errors.passwd = "未入力です";
      if (!this.passwd2) this.errors.passwd2 = "未入力です";

      // エラーがなければサブミット
      if (Object.keys(this.errors).length == 0 && !this.connect_flg) {
        var loader = this.loadingShow();
        // 通信開始
        this.connect_flg = true;
        let params = new URLSearchParams();
        params.append("c", "member-pw");
        params.append("lo_pk", this.$cookies.get("lo_pk"));
        params.append("lo_sid", this.$cookies.get("lo_sid"));
        params.append("now_passwd", this.now_passwd);
        params.append("passwd", this.passwd);
        params.append("passwd2", this.passwd2);

        this.axios
          .post(this.RequestURI, params, {
            headers: {
              "Cache-Control": "no-cache",
            },
          })
          .then((response) => {
            if (response.data.status == "success") {
              // 成功
              loader.hide();
              this.$confirm({
                message: "変更が完了しました",
                button: {
                  yes: "OK",
                },
                /**
                 * Callback Function
                 * @param {Boolean} confirm
                 */
                callback: (confirm) => {
                  if (confirm) {
                    this.$router.push("/");
                  }
                },
              });
            } else if (response.data.status == "inputError") {
              loader.hide();
              // 入力エラー
              // エラーセット
              this.errors = response.data.errors;
              // エラー位置にスクロール
              this.errorScrollBack();
            } else {
              loader.hide();
              // ログインに戻す
              this.removeLogin();
            }
          })
          .catch(() => {
            loader.hide();
            this.removeLogin();
          });
      } else {
        // エラー位置にスクロール
        this.errorScrollBack();
      }
      // 通信終了
      this.connect_flg = false;
    },

    errorScrollBack() {
      //スクロールを最上位へ
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    },
  },
};
</script>